import React, { useEffect, useState } from 'react';

import { clockFace } from './clock';

export interface Props {
  deviceName: string;
}

const clock = () => clockFace();

/** The strip along the top of the pretend phone: its name, and the time. */
const PhoneStatusBar: React.FC<Props> = ({ deviceName }) => {
  const [time, setTime] = useState(clock);
  useEffect(() => {
    const timer = setInterval(() => setTime(clock()), 15_000);
    return () => clearInterval(timer);
  }, []);
  return (
    <div className="Phone_statusBar" aria-hidden="true">
      <span>{deviceName}</span>
      <span className="Phone_statusBarDots">
        <i />
        <i />
        <i />
        <i />
      </span>
      <span>{time}</span>
    </div>
  );
};

export default PhoneStatusBar;
